{
 "hold:carryBlade": {
  "status": "review",
  "round": 3,
  "notes": "R1 comment: Blade sticks out sideways horizontal in front 3/4 views (pole through the arm); raise tip or tuck along the forearm. | R2 review: R2: blade and scabbard still stick out sideways in V in 3/4 views; tuck the blade along the forearm, tip up. | R3: blade steeper (-1.3) and the hand lower ([5,35]) so blade and scabbard no V in 3/4 views."
 },
 "hold:fanChest": {
  "status": "rejected",
  "round": 1,
  "comment": "No fan appears (weapon none): only a fist at the chest; cannot approve without the fan prop drawn.",
  "notes": "blocked: needs a fan in Look.weapon"
 },
 "hold:pointDown": {
  "status": "rejected",
  "comment": "Old hold: blade dangles by the leg like a stick.",
  "round": 1
 },
 "hold:presentLow": {
  "status": "rejected",
  "round": 1,
  "comment": "Blade extends horizontally 40+ px from the body in most views; reads as a bar, not a presentation. Shorten/angle up.",
  "notes": "dropped in R2"
 },
 "hold:revArm": {
  "status": "approved",
  "round": 3,
  "notes": "R1 approved; R2: canted back in right-facing views so the blade shows (QA note) | R2 review: R2: blade visible in right-facing views now. Minor (woman): beige thigh patch at the robe slit in right-facing walk views. | R2b (art minor): forearm turned out in front/3/4 views so the blade shows. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "hold:reverseUp": {
  "status": "rejected",
  "round": 1,
  "comment": "Blade points at the sky with elbow out; awkward, as the user said. Redo or drop.",
  "notes": "dropped in R2"
 },
 "hold:shoulderRest": {
  "status": "rejected",
  "round": 1,
  "comment": "Hand and blade cover the face in S/SW views; lazy bandit read. Move the hand lower or drop.",
  "notes": "dropped in R2"
 },
 "hold:staffShoulder": {
  "status": "rejected",
  "round": 1,
  "comment": "Staff crosses the throat/face in 3/4 front views; sits like a pole over the chin.",
  "notes": "dropped in R2"
 },
 "hold:staffUpright": {
  "status": "rejected",
  "round": 2,
  "notes": "R1 comment: Staff is drawn short and floating, butt not on the ground; overlaps the torso in front views. | blocked: needs a full-length staff design (asked main); wood colours fixed R2b.",
  "comment": "R2: staff is a short pale tube at the hip, not reaching the head and not wood-coloured; plant the butt and raise the top above the shoulder."
 },
 "hold:trailBlade": {
  "status": "rejected",
  "round": 1,
  "comment": "Blade dragged behind at an angle looks sloppy, not a trained bearing.",
  "notes": "dropped in R2"
 },
 "idle:cBalance": {
  "status": "approved",
  "round": 1,
  "comment": "Arms-out one-leg balance: very childlike and clear."
 },
 "idle:cBehind": {
  "status": "approved",
  "round": 1,
  "comment": "Hands behind back, shy."
 },
 "idle:cBounce": {
  "status": "approved",
  "round": 1,
  "comment": "Bouncing, energetic."
 },
 "idle:cClap": {
  "status": "approved",
  "round": 1,
  "comment": "Clapping, clear."
 },
 "idle:cFeet": {
  "status": "approved",
  "round": 1,
  "comment": "Foot tapping/hopping, childlike."
 },
 "idle:cKick": {
  "status": "approved",
  "round": 3,
  "notes": "R1 comment: No visible kick: legs stay planted, reads as a plain stand; raise the kicking foot clearly. | R2 review: R2: knee lift clearly visible. | R2b (art minor): shin swings forward on the kick. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:cLook": {
  "status": "approved",
  "round": 3,
  "notes": "R1 comment: Near-duplicate of cRock; the head turn is not readable at game size. | R2 review: R2: hand-to-brow lookout reads. Minor: hand hides the face in S/SW. | R2b (art minor): hand above the brows so the eyes show. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:cProud": {
  "status": "approved",
  "round": 1,
  "comment": "Hands on hips proud, clear."
 },
 "idle:cRock": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Barely visible motion, near-duplicate of cLook/cBounce; make the rocking heel-to-toe read.",
  "comment": "R2: rocking and arm wings read (best from the back/side views). Minor: front views subtle."
 },
 "idle:cScratch": {
  "status": "approved",
  "round": 1,
  "comment": "Head scratch, clear."
 },
 "idle:cSwing": {
  "status": "approved",
  "round": 1,
  "comment": "Arm swing, playful."
 },
 "idle:cCheer": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Near-duplicate of cSwing (arms hang and swing); add a clear torso twist. | R3: renamed cTwist -> cCheer (เชียร์), motion unchanged.",
  "comment": "R2: arms-up swing distinct from cSwing. Minor: arms straight like a T; torso twist weak, maybe rename to cCheer."
 },
 "idle:eBeard": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Frozen (avg 1.7 px/frame): hand sits at the chin with no stroking motion; also hand hides the face in most views.",
  "comment": "R2: stroking the beard moves now. Minor: hand covers the mouth in S views."
 },
 "idle:eCane": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: No cane drawn: the hand grips air, arm sticks out sideways. Needs the cane prop or a different hand pose.",
  "comment": "R2: cane drawn and planted, both elders."
 },
 "idle:eCough": {
  "status": "approved",
  "round": 1,
  "comment": "Cough into fist, natural (hand covers the face in back-3/4: minor)."
 },
 "idle:eDoze": {
  "status": "approved",
  "round": 1,
  "comment": "Dozing head nod, charming."
 },
 "idle:eRub": {
  "status": "approved",
  "round": 1,
  "comment": "Rubbing hands, natural."
 },
 "idle:eShift": {
  "status": "approved",
  "round": 1,
  "comment": "Big weight shifts, feels old and tired."
 },
 "idle:eSky": {
  "status": "approved",
  "round": 1,
  "comment": "Looks up, hands behind; subtle but fine."
 },
 "idle:eSleeves": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Hands tucked, same as eStoop/eSky; near-duplicate. Merge or differentiate.",
  "comment": "R2: sleeve flick differs from eStoop/eSky. Minor: arms flare wide, slightly stiff."
 },
 "idle:eStoop": {
  "status": "approved",
  "round": 1,
  "comment": "Elder stoop reads clearly."
 },
 "idle:eStretch": {
  "status": "approved",
  "round": 1,
  "comment": "Hands on back stretch, natural."
 },
 "idle:eTired": {
  "status": "approved",
  "round": 1,
  "comment": "Hands on hips, tired."
 },
 "idle:eUpright": {
  "status": "approved",
  "round": 1,
  "comment": "Dignified elder (retired master)."
 },
 "idle:fBack": {
  "status": "approved",
  "round": 1,
  "comment": "Hands behind, clean back view."
 },
 "idle:fFold": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Frozen (avg 7.8 px/frame): dead loop. Add breath/weight drift or drop.",
  "comment": "R2: arms folded, clear breath/weight drift."
 },
 "idle:fHair": {
  "status": "approved",
  "round": 1,
  "comment": "Tucking hair: natural and clear in all views."
 },
 "idle:fHeart": {
  "status": "approved",
  "round": 1,
  "comment": "Hand to heart, distinct and gentle."
 },
 "idle:fHilt": {
  "status": "review",
  "round": 3,
  "notes": "R1 comment: Almost frozen (avg 36 px change/frame) and same silhouette as fPoised; add a real hand-on-hilt shape. | R2 review: R2: still near static (avg 63 px/frame) and no hilt shape; hands just hang at the hip. | R3: left hand on the scabbard, right hand closed over the hilt above it (skeleton: both hands on the hilt), sinks and turns the hilt forward mid-loop; sheathed sword drawn in the sheet."
 },
 "idle:fHip": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Hand on hip, distinct. | R2b (art minor): both hands on the hips. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:fLook": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Gentle look around, acceptable. | R2b (art minor): turn 4 + head 3. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:fPoised": {
  "status": "approved",
  "round": 1,
  "comment": "Poised, straight, long-robe bearing."
 },
 "idle:fSleeves": {
  "status": "approved",
  "round": 1,
  "comment": "Hands in sleeves, graceful."
 },
 "idle:fSway": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Weight sway reads through the robe. | R2b (art minor): wider sway. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:fWatch": {
  "status": "approved",
  "round": 3,
  "notes": "R1 comment: Arms hang beside the robe, near-duplicate of fPoised/fSway; make the watching read with head/eyes + a hand gesture. | R2 review: R2: hand-to-brow lookout in the second half reads. Minor: first half is a plain stand. | R2b (art reject): ponytail no longer driven by the raised arm (cloth ignores idle hand speed). | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:fWuji": {
  "status": "review",
  "round": 3,
  "notes": "R1 comment: Hanging-hands stand, duplicate of fPoised; drop or differentiate. | R2 review: R2: still hanging hands, near static (avg 50); duplicate of fPoised. Lift hands to the belly like mWuji. | R3: hands together at the belly, toe taps twice under the hem, weight sinks with the breath, head follows the eyes."
 },
 "idle:mBall": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Taiji ball: the most martial idle; arm stub reads in side views. | R3 (art reject): near arm as a clasp before the chest so head-on the arms make the ring at chest height (was a sleeve block). | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:mFold": {
  "status": "approved",
  "round": 1,
  "comment": "Arms folded, confident, clean in all views."
 },
 "idle:mGlance": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Natural glance, readable head turn. | R2b (art minor): turn 4 + head 3. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:mHilt": {
  "status": "approved",
  "round": 1,
  "comment": "Hand at the hilt, ready but calm."
 },
 "idle:mHip": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Hands on hips, distinct silhouette. | R2b (art minor): both fists on the hips. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:mMaster": {
  "status": "approved",
  "round": 1,
  "comment": "Hands clasped behind the back: master bearing, reads in all 8 views."
 },
 "idle:mNeck": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Reads as a plain stand (same as mRooted); needs a visible neck-roll/shoulder action or drop.",
  "comment": "R2: arm over the head neck stretch reads in all views."
 },
 "idle:mRock": {
  "status": "approved",
  "round": 1,
  "comment": "Heel-toe rock, weight visibly moves."
 },
 "idle:mRooted": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: Grounded stance, straight spine, weight even. | R2b (art minor): weight on one leg, hands in. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "idle:mSash": {
  "status": "rejected",
  "round": 2,
  "notes": "R1 comment: Hands at the sash like mHilt/mWatch; no distinct silhouette. Merge or make a clear different action. | dropped in R3 (IdleDef.dropped).",
  "comment": "R2: still hands at the sash, same silhouette as mWuji/mHilt; change the action (e.g. tighten sash with a clear elbow movement) or merge."
 },
 "idle:mWatch": {
  "status": "approved",
  "round": 1,
  "comment": "Alert look-around, distinct."
 },
 "idle:mWuji": {
  "status": "approved",
  "round": 2,
  "notes": "R1 comment: Near-duplicate of mRooted (feet apart, hands open at sides); give it a real wuji hold (hands lifted to belly, soft knees) or drop.",
  "comment": "R2: eyes closed, hands low at the belly, soft knees: a real wuji hold now."
 },
 "motion:guardWalk": {
  "status": "review",
  "round": 3,
  "notes": "R2 review: R2: planted foot moves 0.5 px/frame vs 2.2 in walk: feet slide on the ground at the same speed; lower ankle flips between feet. | R3: steps 1.7x so the planted feet keep up with the guarded speed (QA slide)."
 },
 "pose:stepA": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: R2: clean key, feet planted. | R2b/R3: same stride changes as walk. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "pose:stepB": {
  "status": "approved",
  "round": 3,
  "notes": "R2 review: R2: clean key, feet planted. Minor: amplitude differs from stepA (+9 vs -7). | R2b/R3: same stride changes as walk. | R3 re-check: kept approved so the game keeps it; QA/art re-check on the R3 sheets."
 },
 "pose:walk": {
  "status": "review",
  "round": 3,
  "notes": "R2 review: R2: stance asymmetric (A foot planted 9 frames over 18 px, B foot 5 frames over 10 px): reads as a limp. Equalise contact length. | R3: feet unrounded, even planted-foot slide (QA limp; the trace counted double-support frames to foot A, cycle is 9+9 frames). R2b: woman hips 2 px + hem kick/trail, 1 px drop at contact, shoulder counter-turn doubled, elders hunched."
 },
 "pose:walkSheathe": {
  "status": "review",
  "round": 3,
  "notes": "R2 review: R2: same leg cycle as walk (asymmetric stance); blade crosses the face in front views. | R3: arm passes the ready grip in stride, blade off the face."
 },
 "pose:walkUnsheathe": {
  "status": "review",
  "round": 3,
  "notes": "R2 review: R2: same leg cycle as walk (asymmetric stance); hands show no blade at the sampled phases, the action is unreadable. | R3: same as walkSheathe; studio shows the sheathe/draw steps."
 },
 "pose:sprint": {
  "status": "review",
  "round": 3,
  "notes": "R2b: run polish (behind sprint approval)."
 },
 "pose:block": {
  "status": "review",
  "round": 3,
  "notes": "R2b: guard group sheet (sheet:guard)."
 },
 "pose:blockHit": {
  "status": "review",
  "round": 3,
  "notes": "R2b: guard group sheet."
 },
 "motion:guardUp": {
  "status": "review",
  "round": 3,
  "notes": "R2b: guard group sheet."
 },
 "motion:guardHit": {
  "status": "review",
  "round": 3,
  "notes": "R2b: guard group sheet."
 }
}
